module.exports = __webpack_public_path__ + "24e004ab/img/verified-icon.f93bbc14.svg";